'use strict';

module.exports = ['$scope', '$timeout',
    function($scope, $timeout) {
        function getRandomBetween(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }

        function startCountdown() {
            updateProgressBar();
            countdown();
        }

        function countdown() {
            $timeout(() => {
                if($scope.counter <= 0) return;
                $scope.counter--;
                countdown();
            }, 1000);
        }

        function updateProgressBar() {
            $timeout(() => {
                if($scope.progress >= 200) {
                    $scope.progress = 0;
                }
                $scope.progress = $scope.progress+0.5;

                updateProgressBar()
            }, 1)
        }

        $scope.progress = 0;
        $scope.waitFor = getRandomBetween(10000, 16000);
        $scope.counter = Math.floor($scope.waitFor / 1000);
        startCountdown();

        console.log($scope.waitFor, $scope.counter);

        $timeout(() => {
            location.reload();
        }, $scope.waitFor);
    }
];